export default "__VITE_ASSET__BSJT1Pvg__"